import axios from '../requester';
import { API } from '../constants/api-urls';
import { AUTH } from '@linearb/linjs-common';
import { getFetchRepositories as getFetchRepositoriesMock } from './__mocks__/repositories.service';
import { RUN_IN_MOCK_MODE } from 'common/config/mock-server.config';

export const BACKFILL_TYPE = { REPOSITORY: 'RepositoryBackfill' };

export const getFetchRepositories = async ({
  sensor_authorization_id,
  cacheId
}) => {
  if (RUN_IN_MOCK_MODE) {
    return getFetchRepositoriesMock();
  }
  return axios.get(
    `${API.REPOSITORIES_PATH}/fetch`,
    sensor_authorization_id
      ? {
          params: {
            sensor_authorization_id,
            ...(cacheId ? { [AUTH.OAUTH_SECRET_CACHE_ID]: cacheId } : {})
          }
        }
      : {}
  );
};

export const getFetchRepositoriesV2 = async ({
  sensor_authorization_id,
  cacheId,
  params,
  git_org,
  page_size,
  cursor,
  q,
  githubFilterByRepoType
}) => {
  if (RUN_IN_MOCK_MODE) {
    return getFetchRepositoriesMock();
  }
  return axios.get(
    `${API.REPOSITORIES_PATH}/fetch/v2`,
    sensor_authorization_id
      ? {
          params: {
            git_org,
            page_size,
            cursor,
            q,
            sensor_authorization_id,
            ...githubFilterByRepoType,
            ...params,
            ...(cacheId ? { [AUTH.OAUTH_SECRET_CACHE_ID]: cacheId } : {})
          }
        }
      : {}
  );
};

export const getRepositories = async (params = {}) => {
  return axios.get(API.REPOSITORIES_PATH, { params });
};

export const getRepositoriesV2 = async ({ sensor_authorization_id, params }) =>
  axios.get(`${API.REPOSITORIES_PATH}/v2`, {
    params: {
      sensor_authorization_id,
      ...params
    }
  });

export const createRepositories = async (data, backfillType, isV2 = false) => {
  if (isV2) {
    return axios.post(`${API.REPOSITORIES_PATH}/job/v2`, data);
  } else {
    return axios.post(API.REPOSITORIES_PATH, data, {
      params: { job_type: backfillType }
    });
  }
};

export const updateRepository = async (id, data) =>
  axios.patch(`${API.REPOSITORIES_PATH}/${id}`, data);
export const deleteRepository = async id =>
  axios.delete(`${API.REPOSITORIES_PATH}/${id}`);

export const fetchGitUserDetails = async sensorAuthorizationId =>
  axios.get(
    `${API.SENSOR_USER_DETAILS}?sensor_authorization_id=${sensorAuthorizationId}`
  );

/**
 * Updates bulk of repositories by filter.
 * All the repositories that match this filter will be updated with the payload
 * @example updateBulkRepositoriesByFilter({ sensor_authorization_id: 5555 }, { extra: { is_gitstream_enabled: true } })
 * @param {object} filter The Filter for selecting the repositories that need to be updated
 * @param {object} payload payload for the updated.
 * @returns {Promise<any>}
 */
export const updateBulkRepositoriesByFilter = async (filter, payload) =>
  axios.patch(`${API.REPOSITORIES_PATH}/bulk/filter`, {
    where: filter,
    payload
  });
